import React, { Component } from 'react';
import { TouchableOpacity, StyleSheet, View, Text, Picker } from 'react-native';
import { Table, TableWrapper } from '../../components/Table';
import { Row } from '../../components/Rows';
import Cell from '../../components/Cell';
import { Content1, Content2, Content3 } from './Content';

class Appendix3 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            widthArr: [150, 150, 200],
            tableHead: ["Transaction No.", "Transaction Date", "Outstanding Invoice Amount (Domestic Currency)"],
            tableData: [[]],
            initTableData: [
                ["KC_ART_001", "2018-01-01", "2100.00"],
                ["KC_ART_002", "2018-02-01", "18560.50"],
                ["KC_ART_003", "2018-03-01", "100.00"],
                ["KC_ART_004", "2018-04-01", "762.50"],
                ["KC_ART_005", "2018-05-01", "8641.00"],
                ["KC_ART_006", "2018-06-01", "221.10"],
            ],
            dateFrom: '2018-01-01',
            dateTo: '2018-01-01',
            lastDay: '60',
            requestDay: '60',
        }
    };

    componentDidMount() {
        // initial the data
        this._initialData();
    }

    _initialData() {
        // initial Table Data
        var dateObj = new Date();
        var monthObj = dateObj.getUTCMonth() + 1;
        var dayObj = dateObj.getUTCDate();
        var yearObj = dateObj.getUTCFullYear();

        var newData = this.state.initTableData;
        for (let i = 0; i < newData.length; i++) {
            var month = monthObj - (Math.floor(Math.random() * (3) + 1) - 1);
            var day = Math.floor(Math.random() * (28) + 1);
            var year = yearObj;

            if (month === monthObj && day >= dayObj) {
                month = monthObj - 1;
            }

            if (newData.length === i + 1) {
                newData[i][1] = yearObj + "-" + monthObj + "-" + dayObj;
            } else {
                newData[i][1] = year + "-" + month + "-" + day;
            }
        }

        this.setState({
            initTableData: newData,
            tableData: newData,
        });

        // initial Date From and Date To
        var dateFromStr = "";
        var dateToStr = "";

        var dateFrom = new Date();
        dateFrom.setDate(dateFrom.getDate() - parseInt(this.state.lastDay));
        var monthFrom = dateFrom.getUTCMonth() + 1;
        var dayFrom = dateFrom.getUTCDate();
        var yearFrom = dateFrom.getUTCFullYear();

        var dateTo = new Date();
        var monthTo = dateTo.getUTCMonth() + 1;
        var dayTo = dateTo.getUTCDate();
        var yearTo = dateTo.getUTCFullYear();

        dateFromStr = yearFrom + "-" + monthFrom + "-" + dayFrom;
        dateToStr = yearTo + "-" + monthTo + "-" + dayTo;

        this.setState({
            dateFrom: dateFromStr,
            dateTo: dateToStr,
        });
    }

    _updatePickerValue = (value) => {
        this.setState({
            lastDay: value
        });
    }

    _onRefreshData() {
        this._updateTableData();
        this._updateRequestDate();
    }

    _updateTableData() {
        var oneDay = 1000 * 60 * 60 * 24;
        var dateObj = new Date();
        var lastDay = this.state.lastDay;

        var tableData = this.state.initTableData;
        var newData = [[]];
        for (let i = 0; i < tableData.length; i++) {
            var parts = tableData[i][1].split("-");
            var myDate = new Date(parts[0], parts[1] - 1, parts[2]);
            var daydiff = Math.round((dateObj.getTime() - myDate.getTime()) / oneDay);

            if (daydiff < lastDay && daydiff >= 0) {
                newData.push(tableData[i]);
            }
        }

        this.setState({
            tableData: newData,
        });
    }

    _updateRequestDate() {
        var lastDay = this.state.lastDay;

        var dateFromStr = "";
        var dateToStr = "";

        var dateFrom = new Date();
        dateFrom.setDate(dateFrom.getDate() - parseInt(lastDay));
        var monthFrom = dateFrom.getUTCMonth() + 1;
        var dayFrom = dateFrom.getUTCDate();
        var yearFrom = dateFrom.getUTCFullYear();

        var dateTo = new Date();
        var monthTo = dateTo.getUTCMonth() + 1;
        var dayTo = dateTo.getUTCDate();
        var yearTo = dateTo.getUTCFullYear();

        dateFromStr = yearFrom + "-" + monthFrom + "-" + dayFrom;
        dateToStr = yearTo + "-" + monthTo + "-" + dayTo;

        this.setState({
            requestDay: lastDay,
            dateFrom: dateFromStr,
            dateTo: dateToStr,
        });
    }

    render() {
        const state = this.state;

        const element = (data, index, cellIndex) => (
            <Text>
                {'{\n'}
                <Text style={{ color: 'green' }}>
                    {'         "code": "' + data + '",'}
                </Text>
            </Text>
        );

        const element2 = (data, index, cellIndex) => (
            <Text>
                <Text style={{ color: 'red' }}>
                    {'         "tDate": "' + data + '",'}
                </Text>
            </Text>
        );

        const element3 = (data, index, cellIndex) => (
            <Text>
                <Text style={{ color: 'orange' }}>
                    {'         "balInvDomAmt": ' + data + ','}
                </Text>
                {'\n},'}
            </Text>
        );

        return (
            <View style={styles.container}>

                <Content1 />

                <View style={styles.reportContainer}>
                    <View style={styles.reportContent}>
                        <Text style={styles.reportLogoTitle}>
                            {"Outstanding Account Receivable Report"}
                        </Text>
                    </View>
                    <View style={{ paddingTop: 20 }}>
                        <Text style={{ fontSize: 15 }}>
                            {"Customer: CUS001"}
                        </Text>
                        <View style={{ flexDirection: 'row' }}>
                            <Text style={{ fontSize: 15 }}>
                                {"Last "}
                                <Picker selectedValue={this.state.lastDay} onValueChange={this._updatePickerValue}>
                                    <Picker.Item label="60" value="60" />
                                    <Picker.Item label="30" value="30" />
                                    <Picker.Item label="15" value="15" />
                                </Picker>
                                {" days"}
                            </Text>
                        </View>
                    </View>
                    <View style={styles.reportScroll}>
                        <Table borderstyle={{ borderWidth: 2, borderColor: '#c8e1ff' }}>
                            <Row data={state.tableHead} style={styles.head} widthArr={state.widthArr} textStyle={styles.tableText} />
                            {state.tableData.map((rowData, index) => (
                                <TableWrapper key={index} style={styles.row}>
                                    {rowData.map((cellData, cellIndex) => (
                                        <Cell key={cellIndex}
                                            data={cellData}
                                            style={styles.tableBorder}
                                            textStyle={styles.tableText}
                                            width={state.widthArr[cellIndex]}
                                            height={40} />
                                    ))}
                                </TableWrapper>
                            ))}
                        </Table>
                    </View>
                </View>

                <Content2 />

                <Content3 />

                <View style={styles.reportContainer}>
                    <View style={styles.reportContent}>
                        <Text style={styles.reportLogoTitle}>
                            {"Outstanding Account Receivable Report"}
                        </Text>
                    </View>
                    <View style={{ paddingTop: 20 }}>
                        <Text style={{ fontSize: 15 }}>
                            {"Customer: CUS001"}
                        </Text>
                        <View style={{ flexDirection: 'row' }}>
                            <Text style={{ fontSize: 15 }}>
                                {"Last "}
                                <Picker selectedValue={this.state.lastDay} onValueChange={this._updatePickerValue}>
                                    <Picker.Item label="60" value="60" />
                                    <Picker.Item label="30" value="30" />
                                    <Picker.Item label="15" value="15" />
                                </Picker>
                                {" days"}
                            </Text>
                        </View>
                    </View>
                    <View style={styles.reportScroll}>
                        <Table borderstyle={{ borderWidth: 2, borderColor: '#c8e1ff' }}>
                            <Row data={state.tableHead} style={styles.head} widthArr={state.widthArr} textStyle={styles.tableText} />
                            {state.tableData.map((rowData, index) => (
                                <TableWrapper key={index} style={styles.row}>
                                    {rowData.map((cellData, cellIndex) => (
                                        <Cell key={cellIndex}
                                            data={cellData}
                                            style={styles.tableBorder}
                                            textStyle={styles.tableText}
                                            width={state.widthArr[cellIndex]}
                                            height={40} />
                                    ))}
                                </TableWrapper>
                            ))}
                        </Table>
                    </View>
                </View>
                <TouchableOpacity onPress={() => this._onRefreshData()}>
                    <View style={styles.submitBtn}>
                        <Text style={styles.submitBtnText}>Submit</Text>
                    </View>
                </TouchableOpacity>

                <Text style={[styles.subheading, { paddingBottom: 20 }]}>
                    {'Sample request to list Report on Last '}
                    <Text style={{ color: 'red' }}>
                        {state.requestDay}
                    </Text>
                    {" days"}
                </Text>
                <View style={styles.border}>
                    <Text style={[styles.text, { paddingLeft: 80 }]}>
                        {
                            'String beId = "19";'
                            + 'String uId = "9";'
                            + '\nString AIId = "6";'
                            + '\nString recregId = "0";'
                            + '\nString multiRecId = "0";'
                            + '\nString AIType = "cus";'
                        }
                        <Text style={{ color: 'red' }}>
                            {'\nString sDate = "' + state.dateFrom + '";'}
                            {'\nString eDate = "' + state.dateTo + '";'}
                        </Text>
                        {
                            '\nString sDDate = "1900-01-01";'
                            + '\nString eDDate = "9999-12-31";'
                            + '\nString sStaff = "";'
                            + '\nString eStaff = "";'
                            + '\nString loadCrNote = "1";'
                            + '\nString sTranType = "arTran";'
                            + '\nString loadGroupCo = "false";'
                        }
                    </Text>
                    <Text style={[styles.text, { paddingLeft: 80 }]}>
                        {
                            'String url = "http://" + server + "/jsf/rfws/erp/ac/ar/getOsInvoice/'
                            + '\n   + beId + "/"'
                            + '\n   + uId + "/"'
                            + '\n   + AIId + "/"'
                            + '\n   + recregId + "/"'
                            + '\n   + multiPayId;"'
                        }
                    </Text>
                    <Text style={[styles.text, { paddingLeft: 80 }]}>
                        {
                            'Request request = new Request.Builder()'
                            + '\n   .url(url)'
                            + '\n   .addHeader("client_id", clientID)'
                            + '\n   .addHeader("authorization", "Bearer " + token)'
                            + '\n   .addHeader("cache-control", "no-cache")'
                            + '\n   .addHeader("AIType", AIType)'
                            + '\n   .addHeader("sDate", sDate)'
                            + '\n   .addHeader("eDate", eDate)'
                            + '\n   .addHeader("sDDate", sDDate)'
                            + '\n   .addHeader("eDDate", eDDate)'
                            + '\n   .addHeader("sStaff", sStaff)'
                            + '\n   .addHeader("eStaff", eStaff)'
                            + '\n   .addHeader("loadCrNote", loadCrNote)'
                            + '\n   .addHeader("sTranType", sTranType)'
                            + '\n   .addHeader("loadGroupCo", loadGroupCo)'
                            + '\n   .build();'
                        }
                    </Text>
                    <Text style={[styles.text, { paddingLeft: 80, paddingBottom: 20 }]}>
                        {
                            'OkHttpClient client = new OkHttpClient();'
                            + '\nResponse response = client.newCall(request).execute();'
                        }
                    </Text>
                </View>

                <Text style={[styles.subheading, { paddingBottom: 20 }]}>
                    {"Sample Response"}
                </Text>
                <View style={styles.border}>
                    <Text style={{ paddingLeft: 60, paddingTop: 20 }}>
                        {
                            'values:['
                        }
                    </Text>
                    {state.tableData.map((rowData, index) => (
                        <View key={index} style={{ paddingLeft: 90 }}>
                            {rowData.map((cellData, cellIndex) => (
                                <View key={cellIndex}>
                                    {
                                        (cellIndex === 0)
                                            ? element(cellData, index, cellIndex)
                                            : (cellIndex === 1)
                                                ? element2(cellData, index, cellIndex)
                                                : element3(cellData, index, cellIndex)
                                    }
                                </View>
                            ))}
                        </View>
                    ))}
                    <Text style={{ paddingLeft: 60, paddingBottom: 20 }}>
                        {
                            ']'
                        }
                    </Text>
                </View>

            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        width: 700,
    },
    reportContainer: {
        flexDirection: 'column',
        borderWidth: 1,
        borderStyle: 'dashed',
        borderRadius: 20,
        alignItems: 'center',
        height: 450,
    },
    reportContent: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: 20,
    },
    reportLogoTitle: {
        fontSize: 25,
        fontWeight: 'bold',
        paddingLeft: 20,
        fontStyle: 'iTalic'
    },
    shopLogoImage: {
        height: 60,
        width: 180
    },
    reportScroll: {
        paddingTop: 20,
        height: 320,
        flexDirection: 'row',
        width: 650,
        justifyContent: 'center',
    },
    tableBorder: {
        borderWidth: 2,
        borderColor: '#c8e1ff'
    },
    subheading: {
        paddingTop: 20,
        fontSize: 20,
        fontWeight: 'bold',
    },
    text: {
        paddingTop: 20,
    },
    hyperlink: {
        fontStyle: 'iTalic',
        color: 'blue',
        textDecorationLine: 'underline',
    },
    tableText: {
        margin: 6,
        fontSize: 10
    },
    submitContainer: {
        paddingTop: 50
    },
    submitBtn: {
        height: 40,
        borderWidth: 1,
        backgroundColor: '#c8e1ff',
        //borderColor: '#c8e1ff',
        borderRadius: 15,
        justifyContent: 'center',
        alignItems: 'center',
    },
    submitBtnText: {
        fontSize: 15,
        textAlign: 'center',
    },
    border: {
        borderWidth: 1,
    },
    requestContent: {
        height: 500,
        padding: 20,
    },
    responseContent: {
        height: 500,
        padding: 20,
    },
    faqContainer: {
        paddingBottom: 20,
    },
    head: {
        height: 40,
        backgroundColor: '#f1f8ff',
    },
    textInput: {
        margin: 6,
        backgroundColor: 'transparent',
        fontSize: 10
    },
    delBtn: {
        width: 20,
        height: 18,
        backgroundColor: '#c8e1ff',
        borderRadius: 2,
        alignSelf: 'center',
    },
    delBtnText: {
        textAlign: 'center',
        color: '#fff'
    },
    row: {
        flexDirection: 'row',
        overflow: 'hidden',
    },
    refreshImage: {
        height: 20,
        width: 20,
        resizeMode: 'contain'
    },
});

export default Appendix3;



// WEBPACK FOOTER //
// ./src/pages/ap3/Appendix3.js